import React from 'react';
import Helmet from 'react-helmet';
import styled, { keyframes } from 'styled-components';

import Button from '../components/common/Button';
import Header from '../components/header';

import EdmondImage from '../images/about/edmond.png';
import MarcoImage from '../images/about/marco.png';
import CandyImage from '../images/about/candy.png';
import ArslanImage from '../images/about/arslan.png';
import AmelieImage from '../images/about/amelie.png';
import DesireeImage from '../images/about/desiree.png';
import KurtImage from '../images/about/kurt.png';
import RonImage from '../images/about/ron.png';

import { translate } from '../../i18n';

const t = translate('pages/about');

const AboutPageDiv = styled.div`
  min-height: 200px;
  padding: 158px 35px 50px;

  .col-left {
    flex: 0 0 299px;
  }
  .col-left div.title {
    width: 204px;
    font-size: 25px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.28;
    letter-spacing: normal;
    text-align: left;
    color: #2f2e2e;
  }
  .col-right {
    padding-left: 30px;
  }
  .col-right div.wrap-description {
    width: 675px;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.46;
    letter-spacing: normal;
    text-align: left;
    color: #2f2e2e;
  }

  .col-right div.wrap-description .paragraph:not(:first-child) {
    padding-top: 40px;
  }

  @media (max-width: 900px) {
    padding: 108px 15px 50px;
    flex-direction: column;
    .col-left {
      flex: 0 0 100%;
      margin-bottom: 20px;
    }
    .col-left div.title {
      width: 100%;
      font-size: 20px;
    }
    .col-right {
      padding-left: 0;
    }
    .col-right div.wrap-description {
      width: 100%;
      font-size: 19px;
    }
  }
`;

const DivAboutJuven = styled.div`
  display: flex;

  .col-left {
    font-size: 35px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.4;
    text-align: left;
  }

  .description {
    width: 678px;
    font-size: 35px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    color: #2f2e2e;
  }
  .join-us {
    font-size: 35px;
    font-weight: bold;
    padding-top: 10px;
    display: inline-block;
    border-bottom: 7px solid #00a7ff;
    cursor: pointer;
  }
  a {
    line-height: 35px;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    .description {
      width: 100%;
    }
    .col-left,
    .description,
    .join-us {
      font-size: 25px;
    }
  }
`;

const slide_animation = keyframes`
    100% { 
      transform: translateX(-100%);  
    }
`;

const DivImages = styled.div`
  margin: 120px -35px 58px -35px;
  display: block;
  overflow: hidden;
  white-space: nowrap;

  .img-item {
    width: 368px;
    height: 572px;
    display: inline-block;
  }
  .img-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .slideshow {
    animation: ${ slide_animation } 36s linear infinite;
    width: 2944px;
    height: 400px;
    position: relative;
  }
`;

const DivWhatSeemDoing = styled.div`
  display: flex;
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const DivWhatActuallyDoing = styled.div`
  display: flex;
  margin-top: 68px;
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const DivWhereWeWantToGo = styled.div`
  display: flex;
  margin-top: 68px;
  .wrap-description .title {
    font-size: 35px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.26;
    letter-spacing: normal;
    text-align: left;
    color: #2f2e2e;
  }
  @media (max-width: 900px) {
    flex-direction: column;
    .wrap-description .title {
      font-size: 25px;
    }
  }
`;

const DivWhatValueMost = styled.div`
  display: flex;
  margin-top: 68px;
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const DivJuvenStandard = styled.div`
  display: flex;
  margin-top: 68px;
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const DivJoinUs = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: 68px;
  margin-bottom: 30px;
  .title {
    font-size: 35px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.26;
    letter-spacing: normal;
    color: #2f2e2e;
  }
  .btnGroup {
    margin-top: 30px;
  }
  .btn-joinus {
    padding: 0 50px;
  }
  @media (max-width: 900px) {
    flex-direction: column;
    .title {
      font-size: 25px;
    }
  }
`;

const JoinUsButton = styled(Button)`
  border-radius: 50px;
  padding: 15px 50px;
`;

const AboutJuven = (
  <DivAboutJuven>
    <div className='col-left'>
      <div>ABOUT JUVEN</div>
    </div>
    <div className='col-right'>
      <div className='description'>
        { t('Impact and Quality') }
        <br />
        { t('Leadership and Teamwork') }
        <br />
        { t('Creativity and Flexibility') }
        <br />
        { t('Discipline and Integrity') }
      </div>
      <a href='/careers'>
        <div className='join-us'>{ t('JOIN US') }</div>
      </a>
    </div>
  </DivAboutJuven>
);

const memberImages = [
  {
    url: EdmondImage
  },
  {
    url: MarcoImage
  },
  {
    url: CandyImage
  },
  {
    url: ArslanImage
  },
  {
    url: AmelieImage
  },
  {
    url: DesireeImage
  },
  {
    url: KurtImage
  },
  {
    url: RonImage
  }
];
const Images = (
  <DivImages>
    <div className='slideshow'>
      { memberImages.map((item, i) => (
        <div className='img-item' key={ i }>
          <img src={ item.url } />
        </div>
      )) }
      { memberImages.map((item, i) => {
        if (i > 5) return null;
        return (
          <div className='img-item' key={ i }>
            <img src={ item.url } />
          </div>
        );
      }) }
    </div>
  </DivImages>
);
const WhatSeemDoing = (
  <DivWhatSeemDoing>
    <div className='col-left'>
      <div className='title'>{ t('WHAT WE SEEM TO BE DOING') }</div>
    </div>
    <div className='col-right'>
      <div className='wrap-description'>
        { t(
          'We provide a multi-platform ticketing and events software that is unique, refreshing and, most interestingly, charges nothing for any transactions made. We create powerful and intuitive software tools for managing communities, events and payments.'
        ) }
      </div>
    </div>
  </DivWhatSeemDoing>
);

const WhatActuallyDoing = (
  <DivWhatActuallyDoing>
    <div className='col-left'>
      <div className='title'>{ t('WHAT WE ARE ACTUALLY DOING') }</div>
    </div>
    <div className='col-right'>
      <div className='wrap-description'>
        <div className='paragraph'>
          { t(
            'Juven builds and empowers the membership ecosystem for organizations of all types and sizes through technology and design. Here, idea exchange is seamless and intuitive, transactions fast and cost-effective, and engagement easy and creative.'
          ) }
        </div>
        <div className='paragraph'>
          { t(
            'Each of us at Juven plays a distinctive role. Our software engineers build beautifully designed products with the latest technology. Our designers shape perspectives and behaviors that people have towards organizational engagement. Our business team spreads our vision far and wide, building what is to become a wonderful success story.'
          ) }
        </div>
      </div>
    </div>
  </DivWhatActuallyDoing>
);

const WhereWeWantToGo = (
  <DivWhereWeWantToGo>
    <div className='col-left'>
      <div className='title'>{ t('WHERE WE WANT TO GO') }</div>
    </div>
    <div className='col-right'>
      <div className='wrap-description'>
        <div className='title'>
          { t(
            '“We aspire to build the golden standard of organizational engagement.”'
          ) }
        </div>
        <div className='paragraph'>
          { t(
            'We want to be the top company in organisational community development, like McKinsey in consulting, or Goldman Sachs in finance. In fact, senior executives in these firms have invested in us. With our passion, technical expertise and our commitment to quality, we pride ourselves on building partnerships with different organisations and delivering impact.'
          ) }
        </div>
        <div className='paragraph'>
          { t(
            'There are countless organizations building wonderful communities across the globe. We are here to be their technology partner.'
          ) }
        </div>
      </div>
    </div>
  </DivWhereWeWantToGo>
);

const JuvenStandard = (
  <DivJuvenStandard>
    <div className='col-left'>
      <div className='title'>{ t('THE JUVEN STANDARD') }</div>
    </div>
    <div className='col-right'>
      <div className='wrap-description'>
        <div className='paragraph'>
          { t(
            'Juven is impact driven. Juven stands for maintaining professional excellence while remaining agile, responsive and dynamic in a fast-moving industry. We stand for daring to fail, and growing and evolving through to success.'
          ) }
        </div>
      </div>
    </div>
  </DivJuvenStandard>
);

const JoinUs = (
  <DivJoinUs>
    <div className='title'>{ t('We Are Recruiting') }</div>
    <div className='btnGroup'>
      <a href='/careers'>
        <JoinUsButton fullHeight>{ t('JOIN US') }</JoinUsButton>
      </a>
    </div>
  </DivJoinUs>
);

export default () => (
  <div>
    <Helmet title={ t('About | Juven') } />
    <Header showLanguage noScroll />
    <AboutPageDiv>
      { AboutJuven }
      { Images }
      { WhatSeemDoing }
      { WhatActuallyDoing }
      { WhereWeWantToGo }
      { JuvenStandard }
      { JoinUs }
    </AboutPageDiv>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/about.js